import React from 'react';
import { PopularFacetsFragment } from 'src/types';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import { ProductsSection } from 'src/components/products-section';

type Props = PopularFacetsFragment['popularFacets'][0] & {
  landingPage?: boolean;
};

export const PopularFacetsSection: React.FC<Props> = ({
  title,
  url,
  products,
  linkText,
  landingPage,
}) => {
  return (
    <ProductsSection
      products={products}
      title={title}
      linkTitle={linkText}
      linkPath={url}
      onHeaderLinkClick={({ link }) => {
        trackInternalNavigationClick({
          scope: InternalNavigationScope.POPULAR_FACETS_HEADER,
          nextPage: link,
        });
      }}
      onProductCardClick={({ index, link }) => {
        trackInternalNavigationClick({
          scope: InternalNavigationScope.POPULAR_FACETS_PRODUCT_CARD,
          nextPage: link,
          index,
        });
      }}
      landingPage={landingPage}
    />
  );
};
